export default (value, rule) => /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value.toString());



// WEBPACK FOOTER //
// ./src/utils/validate/methods/email.js